import * as React from 'react';

export default class Notification extends React.Component {

    constructor(props) {
        super(props);
    }

    handleClick = () => {
        if (this.props.onClick) {
            this.props.onClick(this.props.notification.id, this.props.type);
        }
    };

    handleClickDelete = () => {
        if (this.props.onDelete) {
            this.props.onDelete(this.props.notification.id);
        }
    };

    displayTitle() {
        let title = this.props.notification.title.replace('_name_', ('<span class="font-weight-bold">' + (this.props.notification.display_name).truncate(30) + '</span>'));
        return {__html: title}
    }

    render() {
        return (
            <tr>
                <td className="align-middle text-gc-dark-blue pl-4 pr-2 h5">
                    <i className={this.props.notification.icon}></i>
                </td>
                <td className="text-nowrap align-middle py-2">
                    <a href={this.props.notification.url} 
                        className={this.props.notification.link_class}
                        onClick={this.handleClick}
                    >
                        <p className="text-gc-dark-blue line-height-normal m-0" dangerouslySetInnerHTML={this.displayTitle()}></p>
                        <p className="small text-muted m-0">
                            {this.props.notification.time_ago}
                            {(nb_hotels > 1 && this.props.notification.detail) && (' - ' + this.props.notification.detail)}
                        </p>
                    </a>
                </td>
                <td className="text-right text-nowrap align-middle px-4 py-2">
                    {this.props.notification.display_suppr_btn && (
                        <button
                            className="btn btn-default btn-suppr-notification text-gc-gray2 p-0"
                            type="button"
                            onClick={this.handleClickDelete}
                        >
                            <i className="far fa-trash-alt"></i>
                        </button>
                    )}
                </td>
            </tr>
        )
    }

}